const NOTIFICATION_TEST_AND_PREVIEW_TYPES = Object.freeze({
  TEST_ALARM_MODEL: 1,
  TEST_SYNTH_ALARM_MODEL: 2,
  TEST_NMS_ALARM_MODEL: 3,
  TEST_INSIGHT_ALARM_MODEL: 4,
  TEST_MITIGATION_ALARM_MODEL: 5
});

const CHANNEL_TYPES = Object.freeze({
  XMATTERS: 'xmatters',
  SLACK: 'slack',
  SERVICENOW: 'servicenow',
  SYSLOG: 'syslog',
  OPSGENIE: 'opsgenie',
  CUSTOM_WEBHOOK: 'custom-webhook',
  SPLUNK: 'splunk',
  MSTEAMS: 'msteams',
  JSON: 'json',
  EMAIL: 'email',
  VICTOROPS: 'victorops',
  PAGERDUTY: 'pagerduty',
  JIRA_CLOUD: 'jira-cloud',
  JIRA_JSM: 'jira-service-management'
});

const SERVICENOW_API_TYPES = Object.freeze({
  TABLE: 'API_TYPE_TABLE',
  EVENT: 'API_TYPE_EVENT'
});

const JIRA_CLOUD_URL_TYPES = Object.freeze({
  SITE: 'URL_TYPE_SITE',
  WEBHOOK: 'URL_TYPE_WEBHOOK'
});

const JIRA_CLOUD_ISSUE_TYPES = Object.freeze({
  TASK: 'Task',
  BUG: 'Bug'
});

const JIRA_CLOUD_ISSUE_TYPE_CUSTOM = '__custom__';

const JIRA_CLOUD_ISSUE_TYPE_OPTIONS = Object.freeze([
  { value: JIRA_CLOUD_ISSUE_TYPES.TASK, label: 'Task' },
  { value: JIRA_CLOUD_ISSUE_TYPES.BUG, label: 'Bug' },
  { value: JIRA_CLOUD_ISSUE_TYPE_CUSTOM, label: 'Custom' }
]);

const TEMPLATE_BASED_CHANNEL_TYPES = [CHANNEL_TYPES.EMAIL, CHANNEL_TYPES.CUSTOM_WEBHOOK];

const OAUTH2_FIELD_IDENTIFIERS = [
  'config.sendingConfig.oauth2AccessTokenURL',
  'config.sendingConfig.oauth2TlsVerify',
  'config.sendingConfig.oauth2TlsPem',
  'config.sendingConfig.oauth2TlsClientCertPem',
  'config.sendingConfig.oauth2TlsClientKeyPem',
  'config.sendingConfig.oauth2ClientId',
  'config.sendingConfig.oauth2ClientSecret',
  'config.sendingConfig.oauth2Scopes'
];

const NOTIFICATION_BROADCAST_CHANNEL_ID = 'notification-broadcast-bridge';

const TEMPLATE_EDITOR_SETTINGS_ROOT = 'notificationTemplateEditor';

const TEMPLATE_EDITOR_DEFAULTS = {
  splitPaneSize: '50%',
  editorThemeLight: 'mdn-like',
  editorThemeDark: 'dracula'
};

const TEMPLATE_GUTTER_ID = 'template-error-gutter';

module.exports = {
  CHANNEL_TYPES,
  SERVICENOW_API_TYPES,
  JIRA_CLOUD_URL_TYPES,
  JIRA_CLOUD_ISSUE_TYPES,
  JIRA_CLOUD_ISSUE_TYPE_CUSTOM,
  JIRA_CLOUD_ISSUE_TYPE_OPTIONS,
  TEMPLATE_BASED_CHANNEL_TYPES,
  TEMPLATE_EDITOR_SETTINGS_ROOT,
  TEMPLATE_EDITOR_DEFAULTS,
  TEMPLATE_GUTTER_ID,
  NOTIFICATION_BROADCAST_CHANNEL_ID,
  OAUTH2_FIELD_IDENTIFIERS,
  NOTIFICATION_TEST_AND_PREVIEW_TYPES
};
